// extracted by mini-css-extract-plugin
export default {"field":"EditForm_field__KE8I6","loader":"EditForm_loader__Du+Ua"};